import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5600cc3b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5600cc3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600cc3b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PlaceCardv2: require('/workspace/components/PlaceCardv2.vue').default})
